module.exports = __webpack_public_path__ + "static/media/user_logo_gray.672a38cc.jpg";